import { createStore } from 'vuex'

export default createStore({
  state: {
    userInfo: {
      avatar: '',
      phone: '',
      nickname: ''
    },
    token: ''
  },
  getters: {
  },
  mutations: {
    // 更新用户手机号
    updateUserPhone(state, info) {
      state.userInfo.phone = info
    },
    // 更新用户信息
    updateUserInfo(state, info) {
      state.userInfo = info
    },
    // 保存token
    saveToken(state, token) {
      state.token = token
    },
    // 退出登录
    logout(state) {
      state.userInfo = {}
      state.token = ''
    },
    // 刷新
    initApp(state) {
      state.userInfo = JSON.parse(window.localStorage.getItem('USER_INFO')) || {}
      state.token = window.localStorage.getItem('TOKEN') || ''
    }
  },
  actions: {
  },
  modules: {
  }
})
